import { CheckoutSuccess } from "./CheckoutSuccess";
import { Configuration } from "./operator/Configuration";
import { Hardware } from "./operator/Hardware";
import { Insights } from "./operator/Insights";
import { OperatorMenu } from "./operator/Menu";
import { OrderList } from "./operator/OrderList";
import { SystemInformation } from "./operator/SystemInformation";
import { OutOfOrder } from "./OutOfOrder";
import { Screensaver } from "./screensaver/Screensaver";
import { SelfCheckout } from "./selfCheckout/SelfCheckout";
import { RootStateKind, useAnyState } from "./state/StateProvider";
// Eslint complains about explicitly importing the html file
import flappy from "../../assets/flappy/flappy.html?url";
import { OperatorSubStateKind } from "../types/Operator";

export const PageSwitcher = () => {
    const { state } = useAnyState();

    const getPage = () => {
        switch (state.kind) {
            case RootStateKind.OutOfOrder:
                return <OutOfOrder />;
            case RootStateKind.Welcome:
                return <Screensaver />;
            case RootStateKind.Scan:
                return <SelfCheckout />;
            case RootStateKind.CheckoutSuccess:
                return <CheckoutSuccess />;
            case RootStateKind.Flappy:
                return <iframe className="h-full w-full" src={flappy}></iframe>;
            case RootStateKind.Operator:
                switch (state.subState.kind) {
                    case OperatorSubStateKind.Idle:
                        return <OperatorMenu />;
                    case OperatorSubStateKind.Orders:
                        return <OrderList />;
                    case OperatorSubStateKind.Insights:
                        return <Insights />;
                    case OperatorSubStateKind.Hardware:
                        return <Hardware />;
                    case OperatorSubStateKind.SystemInformation:
                        return <SystemInformation />;
                    case OperatorSubStateKind.Configuration:
                        return <Configuration />;
                    default:
                        return state.subState satisfies never;
                }
            case RootStateKind.Error:
                return null;
            default:
                return state satisfies never;
        }
    };

    return getPage();
};
